import { GlobalAxios } from "../axios/axios-config";

const INV_ACCO_PAY_LOWERINGS_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ForubusInvAccoPayLowerings/RestartForubusInvAccoPayLoweringsIntegration";

export const restartInvAccoPayLoweringsRetries = ({
  identifier,
}: {
  identifier: number;
}) => {
  return GlobalAxios.put(INV_ACCO_PAY_LOWERINGS_ROUTE, {
    identifier,
  });
};
